// extracted by mini-css-extract-plugin
export default {"viqeoContainer":"h3Yu6","iframeWrap":"DPKXM","iframe":"_6100v"};